export default "__VITE_ASSET__wg3wMviC__"